import comp from "./BulkApplyColumnAction";
export default comp;
